import React from "react";
import { Link } from "react-router";
import styles from "./CookieBanner.module.scss";
import {
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_DECLINED,
  COOKIE_CONSENT_NAME,
} from "../../../config/legal";

const getCookie = (name: string): string | null => {
  const matches = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return matches ? decodeURIComponent(matches[1]) : null;
};

const setCookie = (name: string, value: string) => {
  const date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    date.toUTCString() +
    "; path=/; SameSite=Lax" +
    secure;
};

const clearAnalyticsCookies = () => {
  ["_ym_uid", "_ym_d", "_ym_isad", "_ym_visorc", "_ym_ewf"].forEach((name) => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=." + window.location.hostname + ";";
  });
};

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const consent = getCookie(COOKIE_CONSENT_NAME);
    if (consent === COOKIE_CONSENT_DECLINED) {
      clearAnalyticsCookies();
      return;
    }
    if (consent !== COOKIE_CONSENT_ACCEPTED) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    setCookie(COOKIE_CONSENT_NAME, COOKIE_CONSENT_ACCEPTED);
    setVisible(false);
  };

  const decline = () => {
    setCookie(COOKIE_CONSENT_NAME, COOKIE_CONSENT_DECLINED);
    clearAnalyticsCookies();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Уведомление об использовании файлов cookie">
      <div className={styles.content}>
        <p className={styles.text}>
          Мы используем файлы cookie для работы сайта. Аналитические cookie подключаются только кнопкой «Принять».
          Кнопка «Отказаться» означает отказ от аналитических cookie, сайт при этом продолжает работать.{" "}
          <Link to="/policy">Политика обработки персональных данных</Link>
        </p>
        <div className={styles.buttons}>
          <button type="button" className={styles.accept} onClick={accept}>
            Принять
          </button>
          <button type="button" className={styles.decline} onClick={decline}>
            Отказаться
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
